import { gql } from "@apollo/client";

export const GET_INSTITUCIONES_BY_PACIENTE = gql`
  query InstitucionesByPaciente($idPaciente: Int!, $skip: Int, $take: Int, $where: t_institucionNoSAPFilterInput) {
    institucionesByPaciente(
      idPaciente: $idPaciente
      skip: $skip
      take: $take
      where: $where
    ) {
      totalCount
      items{
        nombre
        cod_Institucion
      }
    }
}`;